import { useCallback, useState } from 'react';

const DISMISS_KEY = 'admin_home_checklist_dismissed';

/**
 * Persist dismiss/restore for the admin Home setup checklist.
 */
export default function useAdminHomeChecklist() {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* ignore */
    }
    setDismissed(true);
  }, []);

  const restore = useCallback(() => {
    try {
      localStorage.removeItem(DISMISS_KEY);
    } catch {
      /* ignore */
    }
    setDismissed(false);
  }, []);

  return {
    visible: !dismissed,
    dismiss,
    restore,
  };
}
